import {
  UserInfoApi
} from './api'
import {
  UserLoginApi
} from './api'
// $UserInfoApiFn()  公用的Userinfo

export function UserInfoApiFn() {
  return new Promise(function (resolve, reject) {
    UserInfoApi({
      name: 123123
    }).then(function (res) {
      lycamWeb.clearCookie();
      if (res && res.data && res.code == 0) {
        resolve(res)
      }
    }).catch(function (err) {
      reject(err)
    })
  })
}
export function UserLoginApiFn() {
  return new Promise(function (resolve, reject) {
    UserLoginApi({
      Appid: 'wxb5a883c5bf26e000',
      Code: lycamWeb.parseQueryString(window.location.href).code,
    }).then(function (res) {
      console.log(res, 'res');
      if (res.code == 1) {
        console.log(window.location.href);
        var newUrl = removeUrlParameter(window.location.href, "code");
        console.log(newUrl);
        window.location.href = newUrl
      }
      resolve(res)
    }).catch(function (err) {
      console.log(err, 'err');
      reject(err)
    })
  })

}

function removeUrlParameter(url, parameter) {
  var urlParts = url.split('?');
  if (urlParts.length >= 2) {
    // 获取参数部分
    var params = urlParts[urlParts.length - 1].split(/[&;]/g);
    console.log(params);
    // 保留不匹配的参数
    var paramsFiltered = params.filter(function (param) {
      return param.split('=')[0] !== parameter;
    });
    let newurl = ""
    urlParts.map((item, index) => {
      if (item.indexOf('#') > -1) {
        const arr = item.split('#')
        item = "#" + arr[arr.length - 1]
      }
      if (index < (urlParts.length - 1)) {
        newurl += item
      } else {
        newurl += (paramsFiltered.length > 0 ? '?' + paramsFiltered.join('&') : '')
      }
    })
    return newurl;
  }
  return url;
}



// WEBPACK FOOTER //
// ./src/request/index.js